var formControls = require('form/controls');

formControls.initMultiSelect = function(){
    
    //SELECT 2
    var multiSelects = $('.multi-select[multiple]');
    $.each(multiSelects,function(index,element){
        var placeHolder = $(element).data('placeholder') ? $(element).data('placeholder') :  'Type de bien';
        $(element).select2({
            placeholder: placeHolder,
            multiple:true,
            escapeMarkup: function (markup) {
                return markup; 
            },
            width: 'style',
            dropdownAutoWidth : true
        });
    });

    $('.megagence-select').multiselect({
        buttonContainer: '<div class="btn-group megagence-select" />',
        nonSelectedText : 'Aucune sélection',
        buttonText: function(options, select) {
            if (options.length === 0) {
             return select.data('selectlabel');
            }
            else {
                var labels = [];
                options.each(function() {
                    if ($(this).attr('label') !== undefined) {
                        labels.push($(this).attr('label'));
                    }
                    else {
                        labels.push($(this).html());
                    }
                });
                return labels.join(', ');
            }
        }
    });
}

formControls.initMultiSelect();

exports.showError = function(element, message) {
    element.addClass('validation-error');
    var options={
        title: message,
        placement : 'bottom',
        trigger: 'manual',
        delay: 0,
        container: false
    };
    element.tooltip(options);
    element.tooltip('show');
};

exports.deleteError = function(element) {
    if(element.hasClass('validation-error')) {
        element.removeClass('validation-error');
        element.tooltip('destroy');
    }
}

exports.autocompleteTowns = function(element, parent) {
    $('#'+ element,parent).selectize({
        delimiter: '_',
        valueField: 'slug',
        labelField: 'name',
        searchField: ['name', 'postalCode', 'id'],
        options: [],
        create: false,
        maxItems: null,
        render: {
            option: function(item, escape) {
                var label = item.name;
                if(item.type === 'city') {
                    label += ' ('+ item.postalCode +')';
                }
                else if (item.type === 'department') {
                    label += ' ('+ item.id +')';
                }
                return '<div>' + escape(label) + '</div>';
            },
            item: function(item, escape) {
                var label = item.name;
                if(item.type === 'city') {
                    label += ' ('+ item.postalCode +')';
                }
                else if (item.type === 'department') {
                    label += ' ('+ item.id +')';
                }
                return '<div class="item">' + escape(label) + '</div>';
            }
        },
        load: function(query, callback) {
            if (!query.length) return callback();
            $.ajax({
                url: '/location-search?q=' + encodeURIComponent(query),
                type: 'GET',
                error: function() {
                    callback();
                },
                success: function(res) {
                    callback(res);
                }
            });
        },
        score: function(search) {
            var score = this.getScoreFunction(search);
            return function(item) {
                var scoreModifier = 1;
                if(item.type === 'postalCode' || item.type === 'fullTown' ) {
                    scoreModifier = 10;
                }
                if(item.type === 'department' || item.type === 'region' ) {
                    scoreModifier = 5;
                }
                return score(item) * scoreModifier;
            };
        },
        onDropdownOpen: function(value) {
            formControls.deleteError($('.selectize-control.'+ element, parent));
        },
        onItemAdd: function(value, $item){ //Invoked when an item is add
            if($(".selectize-input.has-items > div").length > 1){
                $("#distance").prop('disabled', true);
                $("#distance").hide();
            }
        },
        onItemRemove: function(value){ //Invoked when an item is remove
            if($(".selectize-input.has-items > div").length <= 1){
                $("#distance").prop('disabled', false);
                $("#distance").show();
            }
        },
        onInitialize: function() {
            var objects = [];
            if($('#'+ element,parent).data('initialvalues')) {
                $.each($('#'+ element,parent).data('initialvalues'), function (i, b) {
                    objects[b.slug] = b;
                });

                var self = this;
                this.options = objects;

                // Add items
                Object.keys(objects).forEach(function(key) {
                        self.addOption(key);
                        self.addItem(key);
                });

                self.options = self.sifter.items = {};
            }
        },
        plugins: ['remove_button']
    });
}

exports.autocompleteDepartments = function(element, parent) {
    $('#'+ element,parent).selectize({
        delimiter: '_',
        valueField: 'slug',
        labelField: 'name',
        searchField: ['name', 'postalCode', 'id'],
        options: [],
        create: false,
        maxItems: 1,
        render: {
            option: function(item, escape) {
                var label = item.name;
                /*if(item.type === 'city') {
                    label += ' ('+ item.postalCode +')';
                }*/
                if (item.type === 'department') {
                    label += ' ('+ item.id +')';
                }
                return '<div>' + escape(label) + '</div>';
            },
            item: function(item, escape) {
                var label = item.name;
                /*if(item.type === 'city') {
                    label += ' ('+ item.postalCode +')';
                }*/
                if (item.type === 'department') {
                    label += ' ('+ item.id +')';
                }
                return '<div class="item">' + escape(label) + '</div>';
            }
        },
        load: function(query, callback) {
            if (!query.length) return callback();
            $.ajax({
                url: '/location-department-search?q=' + encodeURIComponent(query),
                type: 'GET',
                error: function() {
                    callback();
                },
                success: function(res) {
                    callback(res);
                }
            });
        },
        score: function(search) {
            var score = this.getScoreFunction(search);
            return function(item) {
                var scoreModifier = 1;
                /*if(item.type === 'postalCode' || item.type === 'fullTown' ) {
                    scoreModifier = 10;
                }*/
                if(item.type === 'department' || item.type === 'region' ) {
                    scoreModifier = 5;
                }
                return score(item) * scoreModifier;
            };
        },
        onDropdownOpen: function(value) {
            formControls.deleteError($('.selectize-control.'+ element, parent));
        },
        onInitialize: function() {
            var objects = [];
            if($('#'+ element,parent).data('initialvalues')) {
                $.each($('#'+ element,parent).data('initialvalues'), function (i, b) {
                    objects[b.slug] = b;
                });

                var self = this;
                this.options = objects;

                // Add items
                Object.keys(objects).forEach(function(key) {
                        self.addOption(key);
                        self.addItem(key);
                });

                self.options = self.sifter.items = {};
            }
        },
        plugins: ['remove_button']
    });
}